import { ReactNode } from 'react';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

const RTLCacheProvider = ({ children }: { children: ReactNode }) => {
    const { theme } = useTheme();

    const isRtl = theme.direction === 'rtl';

    // Create ltr cache
    const cacheLtr = createCache({
        key: 'muiltr',
    });

    // Create rtl cache
    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });

    // set the direction on the HTML tag required for native components
    isRtl ? (document.dir = 'rtl') : (document.dir = 'ltr');

    return (
        <CacheProvider value={isRtl ? cacheRtl : cacheLtr}>
            {children}
        </CacheProvider>
    );
};

export default RTLCacheProvider;
